import { call, put, takeLatest } from "redux-saga/effects";
import { getDispositionList } from "../../actions/tempActions";
import { setLoader } from "../../slices/feature/loader/loaderSlice";
import toast from "react-hot-toast";
import { setDispositionList } from "../../slices/feature/tempSlice";
import { dispositionListApi } from "../requests/tempRequests";
import { dispositionListApiType } from "../../../types/tempTypes";
interface dispositionListInterface {
  type: string;
  payload: dispositionListApiType;
}
function* getDispositionListHandler(action: dispositionListInterface): any {
  try {
    const { data } = yield call(dispositionListApi, action.payload);

    yield put(setDispositionList(data));
  } catch (error: any) {
    toast.error(error?.response?.data?.message, { duration: 3000 });
  } finally {
    yield put(setLoader(false));
  }
}

export default function* tempSaga() {
  yield takeLatest(getDispositionList.type, getDispositionListHandler);
}
